@if (showCloseIconOnTop) {
  <div class="dialog-close-icon-wrapper">
    <button mat-icon-button type="button" class="close-button" tabindex="-1" (click)="onDismiss()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}

<h1 mat-dialog-title>
  {{ title }}
</h1>

<mat-divider></mat-divider>

<div mat-dialog-content>
  <p>{{ message }}</p>
</div>

<mat-divider></mat-divider>

<div mat-dialog-actions align="end">
  <button class="gray-button" mat-raised-button (click)="onConfirm()">Yes</button>
  <button class="dark-button" mat-button mat-raised-button (click)="onDismiss()">No</button>
</div>
